<template>
  <span
    >Welcome to <b>Paper Dashboard</b> - a beautiful freebie for every web
    developer.</span
  >
</template>

<script>
export default {

  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },
  
  name: "notification-template",
};
</script>
